import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  userLimitExceededHeader: {
    id: 'LeZR6c',
    defaultMessage: 'User limit exceeded',
    description: 'Header for user limit exceeded modal',
  },
  deactivateToContinue: {
    id: 'dQwpza',
    defaultMessage: 'Your account has exceeded the user limit. Deactivate users to continue using ShipStation.',
    description: 'Message for users with billing permissions to deactivate users',
  },
  contactBillingAdmin: {
    id: 'DbTLeh',
    defaultMessage: 'A user with billing permissions must deactivate users before you can continue.',
    description: 'Message for users without billing permissions',
  },
  contactAdministrator: {
    id: 'hMe9cp',
    defaultMessage: 'Contact an administrator or account manager to resolve this issue.',
    description: 'Contact admin message for blocked users',
  },
  continueButton: {
    id: '3s73DJ',
    defaultMessage: 'Continue',
    description: 'Continue button text',
  },
});
